import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import { gewichtInKgSchema, lengteInCmSchema } from '@common/validation/schemas';
import { type IntoxicationCustomControlData, intoxicationValidation } from './intoxicationSchemas';

export type OsasLifeStyleFormData = IntoxicationCustomControlData & {
    lengthInCm: number | null;
    page?: number;
    weightInKg: number | null;
};

export const osasLifestyleQuestionnaireSchema = Koi.object({
    lengthInCm: lengteInCmSchema.allow(null),
    weightInKg: gewichtInKgSchema.allow(null),
    ...intoxicationValidation,
    page: Koi.number().optional(),
});

export type OsasLifeStyleFormReadData = OsasLifeStyleFormData & {
    alcoholConsumption: string[];
    weight_length_bmi: string[];
    years_packs: string[];
};

export type OsasLifeStyleFormReadKey = keyof OsasLifeStyleFormReadData;

type OsasLifeStyleFormReadLabel =
    | 'Gewicht / lengte / BMI'
    | 'Alcoholconsumptie'
    | 'Dagen per week / glazen per dag'
    | 'Gestopt sinds'
    | 'Roken'
    | 'Jaar / pakjes per dag / pakjaren'
    | 'Drugsgebruik'
    | 'Toelichting';

export const osasLifestyleQuestionnaireReadSchema: TypedReadSchema<
    OsasLifeStyleFormReadKey,
    OsasLifeStyleFormReadLabel
>[] = [
    {
        items: [
            { key: 'weight_length_bmi', label: 'Gewicht / lengte / BMI' },
            { key: 'isAlcoholUser', label: 'Alcoholconsumptie' },
            { key: 'alcoholConsumption', label: 'Dagen per week / glazen per dag' },
            { key: 'alcoholStoppedSince', label: 'Gestopt sinds' },
            { key: 'isSmoker', label: 'Roken' },
            { key: 'years_packs', label: 'Jaar / pakjes per dag / pakjaren' },
            { key: 'smokingStoppedSince', label: 'Gestopt sinds' },
            { key: 'isSmokerRemark', label: 'Toelichting' },
            { key: 'isDrugUser', label: 'Drugsgebruik' },
            { key: 'drugUseStoppedSince', label: 'Gestopt sinds' },
            { key: 'isDrugUserRemark', label: 'Toelichting' },
        ],
    },
];
